/***
 * //////////////////////////////////////////////////////////////
 * TYPES (タイプ)
 * ----------------------
 *
 * タイプは、アクション、リデューサ、saga(または他の)ミドルウェアで使用するための定数です。
 * Typeはアクションの中で、ミドルウェアやリデューサーに命令を伝えるために使われます。
 * 全てのアクションタイプは、グループ化しやすいように以下の配列に格納され、選択されます。
 * //////////////////////////////////////////////////////////////
 */

/**
 * アプリケーションエラー
 * @type {string}
 */
export const ERROR_OCCURRED_EVENT = 'ERROR_OCCURRED_EVENT'
export const ERROR_CONFIRM_EVENT = 'ERROR_CONFIRM_EVENT'

/**
 * ユーザープロファイルの取得
 * @type {string}
 */
export const GET_MANAGER_PROFILE = 'GET_MANAGER_PROFILE'
export const GET_MANAGER_PROFILE_SUCCESS = 'GET_MANAGER_PROFILE_SUCCESS'
export const GET_MANAGER_PROFILE_FAILURE = 'GET_MANAGER_PROFILE_FAILURE'

/**
 * ユーザープロファイルの一時的な削除
 */
export const CLEAR_MANAGER_PROFILE = "CLEAR_MANAGER_PROFILE"

/**
 * アクセストークン
 * @type {string}
 */
export const ACCESS_TOKEN_FAILURE = "ACCESS_TOKEN_FAILURE"

/***
 * デバッグ用のみ
 * @type {string}
 */
export const DEBUG_RESPONSE = "DEBUG_RESPONSE"
export const DEBUG_RESPONSE_CLEAR = "DEBUG_RESPONSE_CLEAR"

/**
 * エラー送信
 */
export const DEBUG_SEND_ERROR_REPORT = "DEBUG_SEND_ERROR_REPORT"
export const DEBUG_SEND_ERROR_REPORT_SUCCESS = "DEBUG_SEND_ERROR_REPORT_SUCCESS"
export const DEBUG_SEND_ERROR_REPORT_FAILURE = "DEBUG_SEND_ERROR_REPORT_FAILURE"

/**
 * サイドバーリンクのロードエベント
 */
export const LOAD_SIDEBAR_LINKS = "LOAD_SIDEBAR"

const types = {
    ERROR_OCCURRED_EVENT,
    ERROR_CONFIRM_EVENT,

    GET_MANAGER_PROFILE,
    GET_MANAGER_PROFILE_SUCCESS,
    GET_MANAGER_PROFILE_FAILURE,

    ACCESS_TOKEN_FAILURE,
    DEBUG_RESPONSE,
    DEBUG_RESPONSE_CLEAR,

    DEBUG_SEND_ERROR_REPORT,
    DEBUG_SEND_ERROR_REPORT_SUCCESS,
    DEBUG_SEND_ERROR_REPORT_FAILURE,

    LOAD_SIDEBAR_LINKS,
    CLEAR_MANAGER_PROFILE
}
export default types;
